import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "avatar-cropper" }
const _hoisted_2 = { class: "avatar-container" }
const _hoisted_3 = { class: "avatar-crop" }
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = { class: "dialog-btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_vueCropper = _resolveComponent("vueCropper")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      title: "",
      class: "cropper-dialog",
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      "show-close": false,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "destroy-on-close": "",
      width: "600px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("div", {
            class: "reupload",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reupload && _ctx.reupload(...args)))
          }, [
            _withDirectives(_createElementVNode("span", null, "Re-upload", 512), [
              [_vShow, _ctx.options.img]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_button, {
              size: "large",
              onClick: _ctx.closeDialog
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Back")
              ])),
              _: 1,
              __: [3]
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              size: "large",
              type: "success",
              onClick: _ctx.getCrop
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("Save")
              ])),
              _: 1,
              __: [4]
            }, 8, ["onClick"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_el_upload, {
              class: "upload",
              ref: "elUpload",
              action: "#",
              "on-change": _ctx.upload,
              accept: "image/png, image/jpeg, image/jpg,image/svg+xml",
              "show-file-list": false,
              "auto-upload": false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  slot: "trigger",
                  type: "success",
                  ref: "uploadBtn"
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("Select Picture")
                  ])),
                  _: 1,
                  __: [2]
                }, 512)
              ]),
              _: 1
            }, 8, ["on-change"])
          ], 512), [
            [_vShow, !_ctx.options.img]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_3, [
            _createVNode(_component_vueCropper, {
              class: "crop-box",
              ref: "cropper",
              img: _ctx.options.img,
              info: _ctx.options.info,
              autoCrop: _ctx.options.autoCrop,
              fixedBox: _ctx.options.fixedBox,
              canMoveBox: _ctx.options.canMoveBox,
              autoCropWidth: _ctx.options.autoCropWidth,
              autoCropHeight: _ctx.options.autoCropHeight,
              centerBox: _ctx.options.centerBox,
              fixed: _ctx.options.fixed,
              fixedNumber: _ctx.options.fixedNumber,
              canMove: _ctx.options.canMove,
              canScale: _ctx.options.canScale
            }, null, 8, ["img", "info", "autoCrop", "fixedBox", "canMoveBox", "autoCropWidth", "autoCropHeight", "centerBox", "fixed", "fixedNumber", "canMove", "canScale"])
          ], 512), [
            [_vShow, _ctx.options.img]
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}